export default __webpack_public_path__ + "static/media/lahore.89405d34.png";